'use client'

import { format } from 'date-fns'
import Image from 'next/image'
import Link from 'next/link'
import { FaCalendarDays } from 'react-icons/fa6'
import { getLocale, getLocalizedUri, LangCode } from '../i18n/lang-context'

/**
 * Post Component
 * ---------------------------------------------------------------------------------------------------------------------
 */
export default function PostCardFeatured(props: { post: any, fullWidth?: boolean, width?: number, height?: number, langCode: LangCode }) {

  const langCode = props.langCode
  // Rendering
  //--------------------------------------------------------------------------------------------------------------------
  return (
    <Link id='POST_CARD_FEATURED'
      href={getLocalizedUri('/blog/' + props.post.slug, langCode)} passHref
      className={'shadow-md hover:shadow-lg flex flex-col bg-main-lightest overflow-hidden shrink-0 cursor-pointer transition-all duration-300 ease-out ' +
        (props.fullWidth ? '' : 'rounded-lg')}
      style={{
        width: props.fullWidth ? '100%' : (props.width + 'px'),
        height: props.height + 'px'
      }}>
      <div id='FEATURED_IMAGE' className={'relative h-full w-full'}>
        {props.post.featuredImage ?
          (<Image src={props.post.featuredImage.url} alt={props.post.featuredImage.alt||''}
            className={'object-cover'} width={0} height={0} fill sizes='50vw' />) :
          (<></>)}
        <div id='CARD_CONTENT' className={'text-main-lightest absolute bottom-0 left-0 flex h-fit w-full items-center justify-between gap-4 bg-black/50 p-4'}>
          <div id='POST_TITLE' className={'truncate whitespace-nowrap text-center text-[12px] font-[400] text-white'}>{props.post.title}</div>
          <div id='LAST_UPDATE' className={'flex w-fit items-center justify-center text-white'}>
            <FaCalendarDays className={'-mt-1 mr-2 h-4 w-4'} />
            <div id='LAST_UPDATE_DATE' className={'whitespace-nowrap text-[10px] font-[300]'}>
              {format(new Date(props.post.publishedAt), 'P', { locale: getLocale(langCode) })}
            </div>
          </div>
        </div>
      </div>
    </Link>
  )

}
